import React from "react";

import "./PanelCard.css";

export default function PanelCard({
  children,
  className = "",
  as: Component = "section",
  ...rest
}) {
  const rootClass = ["PanelCard", className].filter(Boolean).join(" ");

  return (
    <Component className={rootClass} {...rest}>
      {children}
    </Component>
  );
}
